/**
 * Calendar day for a GraphQL `Date` input (`YYYY-MM-DD` only).
 * A missing or unusable document date falls back to today.
 */
export function graphQlDateOnly(value: unknown): string {
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value;
  }
  const date = value instanceof Date && !Number.isNaN(value.getTime()) ? value : new Date();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}
